export const questionColours = {
    1: "#d4e5f1",
    2: "#f6edf9",
    3: "#e2f5f1",
    4: "#FCF3CF",
    5: "#FAE5D3",
    6: "#ded8d8",
    7: "#FBFCFC",
    8: "#EAEDED",
    9: "F5C3F3"
}

export const groupColours = {
    1: "#319be6",
    2: "#7e4a90",
    3: "#466962",
    4: "#948856",
    5: "#d3894b",
    6: "#766160",
    7: "#000",
    8: "#676767",
    9: "F5C3F3"
}